import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary, OfflineBanner } from '@/components';
import { NavigationFeedback } from './NavigationFeedback';
import AppProviders from './providers';
import AppRouter from './router';

export default function App() {
  return (
    <AppProviders>
      <OfflineBanner />
      <ErrorBoundary>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <NavigationFeedback>
            <AppRouter />
          </NavigationFeedback>
        </BrowserRouter>
      </ErrorBoundary>
    </AppProviders>
  );
}
